import mysqlLogoUrl from '@/assets/images/integrations/mysql.svg';
import postgresqlLogoUrl from '@/assets/images/integrations/postgresql.svg';
import snowflakeLogoUrl from '@/assets/images/integrations/snowflake.svg';
import bigqueryLogoUrl from '@/assets/images/integrations/bigquery.svg';
import redshiftLogoUrl from '@/assets/images/integrations/redshift.svg';
import sqlserverLogoUrl from '@/assets/images/integrations/sqlserver.svg';
import { SQL_DATABASE_TYPES, type SqlDatabaseType } from '@/services/db/sql-import-database/entity';

/** Whether an engine is a transactional database or an analytics warehouse; copy reads differently for each. */
export type SqlStorageKind = 'database' | 'data warehouse';

export interface SqlDatabaseInfo {
  /** The product name, e.g. "Amazon Redshift". */
  name: string;
  imageSrc: string;
  documentationUrl: string;
  store: SqlStorageKind;
}

/** The display metadata for each engine a SQL import can read from. */
export const SQL_DATABASE_CATALOG = {
  mysql: {
    name: 'MySQL',
    imageSrc: mysqlLogoUrl,
    documentationUrl: 'https://docs.customer.io/sql-sync/',
    store: 'database',
  },
  postgres: {
    name: 'PostgreSQL',
    imageSrc: postgresqlLogoUrl,
    documentationUrl: 'https://docs.customer.io/postgres-sync/',
    store: 'database',
  },
  snowflake: {
    name: 'Snowflake',
    imageSrc: snowflakeLogoUrl,
    documentationUrl: 'https://docs.customer.io/snowflake-sync/',
    store: 'data warehouse',
  },
  bigquery: {
    name: 'BigQuery',
    imageSrc: bigqueryLogoUrl,
    documentationUrl: 'https://docs.customer.io/bigquery-sync/',
    store: 'data warehouse',
  },
  redshift: {
    name: 'Amazon Redshift',
    imageSrc: redshiftLogoUrl,
    documentationUrl: 'https://docs.customer.io/redshift-sync/',
    store: 'data warehouse',
  },
  sqlserver: {
    name: 'Microsoft SQL Server',
    imageSrc: sqlserverLogoUrl,
    documentationUrl: 'https://docs.customer.io/ms-sql-sync/',
    store: 'database',
  },
} as const satisfies Record<SqlDatabaseType, SqlDatabaseInfo>;

/** Narrow a URL segment to an engine, or null when it is not one. */
export function toSqlDatabaseType(segment: string): SqlDatabaseType | null {
  return SQL_DATABASE_TYPES.find((type) => type === segment) ?? null;
}
